export type RecordingEvidence = {
  state: 'located' | 'approximate' | 'ambiguous' | 'unmatched' | 'unavailable';
  locator: string | null;
  moreLocations: boolean;
  anchors: { start: number; end: number; approximate: boolean; locator: string }[];
};

export function recordingEvidenceLocator(
  evidence: RecordingEvidence | null | undefined,
  selection = '',
): string | null {
  if (!evidence || ['unmatched', 'unavailable'].includes(evidence.state)) return null;
  if (selection !== '') {
    if (!/^\d+$/.test(selection)) return null;
    return evidence.anchors[Number(selection)]?.locator || null;
  }
  return evidence.state === 'ambiguous' ? null : evidence.locator || null;
}

export function recordingEvidenceMessage(evidence: RecordingEvidence | null | undefined): string {
  switch (evidence?.state) {
    case 'located': return 'Zitat im gespeicherten Transkript gefunden. Prüfe die Aussage an der Originalaufnahme.';
    case 'approximate': return 'Zitat im gespeicherten Transkript gefunden; die genaue Stelle ist offen. Gleiche die Aussage mit der Originalaufnahme ab.';
    case 'ambiguous': return 'Das Zitat kommt an mehreren Stellen vor. Wähle die passende Fundstelle und prüfe sie an der Originalaufnahme.';
    case 'unmatched': return 'Dieses Zitat wurde im gespeicherten Transkript nicht gefunden. Prüfe die Originalaufnahme und ergänze Angaben bei Bedarf manuell im Plan.';
    default: return 'Für diesen Vorschlag fehlt ein prüfbares Transkript. Gleiche Angaben mit der Originalaufnahme ab und ergänze sie bei Bedarf manuell im Plan.';
  }
}
